import { Alert, Box, Button, Typography, useTheme } from '@mui/material'
import { CSSProperties } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export const CTAPcfAtScale = ({
	justifyContent = 'initial',
	variant = 'default',
	translationContext,
}: {
	justifyContent?: CSSProperties['justifyContent']
	variant?: 'default' | 'alert'
	translationContext?: string
}) => {
	const theme = useTheme()
	const { t } = useTranslation()
	if (variant === 'alert') {
		const contactUsButton = (
			<Button
				variant="contained"
				href="https://www.co2ai.com/request-a-demo"
				target="_blank"
				rel="noreferrer"
			>
				{t('button.contactUs')}
			</Button>
		)
		return (
			<Alert severity="info" variant="filled" action={contactUsButton}>
				{t('pcfCallToAction', { context: translationContext })}
			</Alert>
		)
	}
	return (
		<Box
			display="flex"
			alignItems="center"
			pb={2}
			mt={2}
			justifyContent={justifyContent}
		>
			<Typography variant="body2" color={theme.palette.fonts.secondary}>
				{/* eslint-disable react/jsx-no-literals */}
				<Trans i18nKey="pcfCallToActionWithLink" context={translationContext}>
					Looking to calculate product carbon footprint at scale for your
					product portfolio?{' '}
					<a
						href="https://www.co2ai.com/request-a-demo"
						target="_blank"
						rel="noreferrer"
					>
						contact us
					</a>
				</Trans>
				{/* eslint-enable react/jsx-no-literals */}
			</Typography>
		</Box>
	)
}
